import {
  USER_TYPE_PAGE,
  USER_TYPE_USER,
  ROLE_ADMIN,
  ROLE_MODERATOR,
  ROLE_ROOT,
} from "../../utils/index";
import * as jwtService from "../../services/jwt.service";

const resolveRole = () => {
  const jwtToken = jwtService.get();
  if (!jwtToken) {
    return null;
  }
  if (jwtToken.isRoot === true) {
    return ROLE_ROOT;
  }
  if (jwtToken.isAdmin === true) {
    return ROLE_ADMIN;
  }
  return ROLE_MODERATOR;
};

const MENU_DEFINITION = [
  {
    icon: "icon-home",
    label: "Tableau de bord",
    to: "/",
    root: true,
    admin: true,
    moderator: true,
  },

  {
    icon: "icon-pie-chart",
    label: "Statistiques",
    to: "/stats",
    permission: "stats",
    root: true,
    admin: true,
    moderator: true,
  },

  {
    icon: "icon-paper-clip",
    label: process.env.REACT_APP_SOCIAL_HUB
      ? process.env.REACT_APP_APP_NAME || "Social Hub"
      : "MyOpinion",
    content: [
      {
        label: "Utilisateurs",
        to: `/users?user_type=${USER_TYPE_USER}`,
        permission: "users",
        root: true,
        admin: true,
        moderator: true,
      },
      {
        label: "Pages",
        to: `/users?user_type=${USER_TYPE_PAGE}`,
        permission: "users",
        root: true,
        admin: true,
        moderator: true,
      },
      {
        label: process.env.REACT_APP_SOCIAL_HUB ? "Groupes" : "Agoras",
        to: "/agoras",
        permission: "agoras",
        root: true,
        admin: true,
        moderator: true,
      },
      {
        label: "Lives",
        to: "/lives",
        permission: "agoras",
        root: true,
        admin: true,
        moderator: true,
      },
      {
        label: process.env.REACT_APP_SOCIAL_HUB ? "Posts" : "Opinions",
        to: "/opinions",
        permission: "opinions",
        root: true,
        admin: true,
        moderator: true,
      },
      {
        label: process.env.REACT_APP_SOCIAL_HUB
          ? "Posts (boostés)"
          : "Opinions (boostées)",
        to: "/opinions?boosted=1",
        permission: "opinions",
        root: true,
        admin: true,
        moderator: true,
      },
      {
        label: "Challenges",
        to: "/challenges",
        permission: "challenges",
        root: true,
        admin: true,
        moderator: true,
      },
      {
        label: "Evénements",
        to: "/events",
        permission: "events",
        root: true,
        admin: true,
        moderator: true,
        socialhub_only: true,
      },
      {
        label: "Commentaires",
        to: "/comments",
        permission: "comments",
        root: true,
        admin: true,
        moderator: true,
      },
      {
        label: "Reports",
        to: "/reports",
        permission: "reports",
        root: true,
        admin: true,
        moderator: true,
      },
      {
        label: "Awards",
        to: "/awards",
        permission: "awards",
        root: true,
        admin: true,
        moderator: true,
        myopinion_only: true,
      },
      {
        label: "Validation d'identité",
        to: "/verifications",
        permission: "verifications",
        root: true,
        admin: true,
        moderator: true,
        myopinion_only: true,
      },
      {
        label: "Abonnements",
        to: "/subscriptions",
        permission: "subscriptions",
        root: true,
        admin: true,
        moderator: true,
        myopinion_only: true,
      },
    ],
    contentIndex: 3,
    root: true,
    admin: true,
    moderator: true,
  },
  {
    icon: "icon-credit-card",
    label: "Monétisation",
    content: [
      {
        label: "Statistique",
        to: "/payments/statistics",
        permission: "monetization",
        root: true,
        admin: true,
        moderator: true,
      },
      {
        label: "Liste des portefeuilles",
        to: "/wallets",
        permission: "monetization",
        root: true,
        admin: true,
        moderator: true,
      },
      {
        label: "Liste des comptes monétisés",
        to: "/payments/cashout",
        permission: "monetization",
        root: true,
        admin: true,
        moderator: true,
      },
      {
        label: "Retrait manuel",
        to: "/payments/manual-withdrawal",
        permission: "monetization",
        root: true,
        admin: true,
        moderator: true,
      },
      {
        label: "Liste des retraits",
        to: "/payments",
        permission: "monetization",
        root: true,
        admin: true,
        moderator: true,
      },
    ],
    contentIndex: 6,
    root: true,
    admin: true,
    moderator: true,
  },
  {
    icon: "icon-users",
    label: "Ressources humaines",
    content: [
      {
        label: "Soldes de conges",
        to: "/hr/holidays_balance",
        permission: "hr",
        root: true,
        admin: true,
        moderator: true,
      },
    ],
    contentIndex: 5,
    root: true,
    admin: true,
    moderator: true,
    socialhub_only: true,
  },
  {
    icon: "icon-layers",
    label: "Gestion de paiement",
    content: [
      {
        label: "Vue d'ensemble",
        to: "/payment-settings",
        permission: "payment_settings",
        root: true,
        admin: true,
        moderator: true,
      },
      {
        label: "Pays et frais",
        to: "/payment-countries",
        permission: "payment_settings",
        root: true,
        admin: true,
        moderator: true,
      },
      {
        label: "Méthodes de paiement",
        to: "/payment-methods",
        permission: "payment_settings",
        root: true,
        admin: true,
        moderator: true,
      },
      {
        label: "Providers",
        to: "/payment-providers",
        permission: "payment_settings",
        root: true,
        admin: true,
        moderator: true,
      },
    ],
    contentIndex: 5.5,
    root: true,
    admin: true,
    moderator: true,
  },
  {
    icon: "icon-lock",
    label: "Securité",
    content: [
      {
        label: "Moderateurs",
        to: "/moderateurs",
        root: true,
        admin: false,
        moderator: false,
      },
      {
        label: "Rôles et permissions",
        to: "/roles",
        root: true,
        admin: false,
        moderator: false,
      },
      {
        label: "Hubs",
        to: "/hubs",
        permission: "security",
        root: true,
        admin: true,
        moderator: false,
        myopinion_only: true,
      },
      {
        label: "Autorisations",
        to: "/authorizations",
        permission: "security",
        root: true,
        admin: true,
        moderator: false,
        socialhub_only: true,
      },
      {
        label: "Demandes d'autorisations",
        to: "/authorization-requests",
        permission: "security",
        root: true,
        admin: true,
        moderator: false,
        socialhub_only: true,
      },
      {
        label: "Rapport d'activités",
        to: "/logs",
        permission: "logs",
        root: true,
        admin: true,
        moderator: true,
      },
    ],
    contentIndex: 8,
    root: true,
    admin: true,
    moderator: true,
  },
  {
    icon: "icon-settings",
    label: "Paramètres",
    to: "/settings",
    permission: "settings",
    root: true,
    admin: true,
    moderator: false,
  },
];

const itemVisibleForRole = (obj, role, permissions) => {
  if (role === ROLE_ROOT) {
    return obj.root === true;
  }
  // Permissions par module (rôles) : fournies par l'API à la connexion. Sans elles (ancien token),
  // on retombe sur les droits par type de compte.
  if (Array.isArray(permissions) && obj.permission) {
    return permissions.includes(obj.permission);
  }
  switch (role) {
    case ROLE_ADMIN:
      return obj.admin === true;
    case ROLE_MODERATOR:
      return obj.moderator === true;
    default:
      return obj.moderator === true;
  }
};

const SECTION_ORDER = ["overview", "community", "moderation", "finance", "organization", "administration"];
const SECTION_LABELS = {
  overview: "Vue d'ensemble",
  community: "Communauté",
  moderation: "Modération",
  finance: "Finance",
  organization: "Organisation",
  administration: "Administration",
};
// Modules (clés de permission) classés par catégorie quand les entrées sont à plat.
const MODERATION_PERMISSIONS = ["reports", "awards", "verifications", "subscriptions"];
// Conteneurs conservés comme groupes repliables, par catégorie.
const CONTAINER_SECTIONS = {
  "Statistiques": "overview",
  "Monétisation": "finance",
  "Gestion de paiement": "finance",
  "Ressources humaines": "organization",
};
// Icône des entrées à plat, d'après leur chemin.
const ICON_BY_PATH = [
  ["/users?user_type=" + USER_TYPE_PAGE, "icon-layers"],
  ["/users", "icon-user"],
  ["/opinions?boosted", "icon-fire"],
  ["/opinions", "icon-bubbles"],
  ["/challenges", "icon-trophy"],
  ["/lives", "icon-microphone"],
  ["/events", "icon-calendar"],
  ["/comments", "icon-bubble"],
  ["/agoras", "icon-globe"],
  ["/reports", "icon-flag"],
  ["/awards", "icon-badge"],
  ["/verifications", "icon-check"],
  ["/subscriptions", "icon-diamond"],
  ["/moderateurs", "icon-shield"],
  ["/roles", "icon-key"],
  ["/hubs", "icon-link"],
  ["/authorizations", "icon-lock"],
  ["/authorization-requests", "icon-envelope"],
  ["/logs", "icon-notebook"],
];
const iconFor = (to = "") => (ICON_BY_PATH.find(([prefix]) => to.startsWith(prefix)) || [])[1] || "icon-list";

/**
 * Construit le menu à partir du JWT actuel (localStorage), rangé par catégories (en-têtes de section) :
 * Vue d'ensemble, Communauté, Modération, Finance, Organisation, Administration.
 * Ne pas figer le menu au chargement du module : au premier import le token peut être absent
 * et des entrées du menu peuvent disparaître.
 */
const buildMetisMenu = (t = (text) => text) => {
  const role = resolveRole();
  const permissions = (jwtService.get() || {}).permissions;

  const visible = (obj) => {
    if (obj.myopinion_only && process.env.REACT_APP_SOCIAL_HUB) return false;
    if (obj.socialhub_only && !process.env.REACT_APP_SOCIAL_HUB) return false;
    return itemVisibleForRole(obj, role, permissions);
  };
  const strip = ({ root, admin, moderator, permission, socialhub, myopinion_only, socialhub_only, content, contentIndex, ...rest }) => rest;

  const sections = {};
  const add = (section, item) => {
    (sections[section] = sections[section] || []).push(item);
  };
  const flat = (child, section) => add(section, { ...strip(child), icon: child.icon || iconFor(child.to), label: t(child.label) });

  MENU_DEFINITION.filter(visible).forEach((obj) => {
    if (!Array.isArray(obj.content)) {
      // Entrées simples : tableau de bord, paramètres.
      add(obj.to === "/" || obj.to === "/stats" ? "overview" : "administration", { ...strip(obj), label: t(obj.label) });
      return;
    }

    const children = obj.content.filter(visible);
    if (children.length === 0) return;

    if (CONTAINER_SECTIONS[obj.label]) {
      // Groupe repliable conservé (statistiques, finance, RH).
      let index = Number.parseFloat(obj.contentIndex || 0);
      add(CONTAINER_SECTIONS[obj.label], {
        ...strip(obj),
        label: t(obj.label),
        content: children.map((child) => {
          index += 0.1;
          return { id: index.toString(), ...strip(child), label: t(child.label) };
        }),
      });
    } else if (children.some((child) => String(child.to || "").startsWith("/users"))) {
      // Conteneur « communauté » : ses entrées passent à plat, Communauté ou Modération selon le module.
      children.forEach((child) => flat(child, MODERATION_PERMISSIONS.includes(child.permission) ? "moderation" : "community"));
    } else {
      // Sécurité : entrées à plat dans Administration.
      children.forEach((child) => flat(child, "administration"));
    }
  });

  let counter = 0;
  const menu = [];
  SECTION_ORDER.forEach((key) => {
    if (!sections[key] || sections[key].length === 0) return;
    menu.push({ id: `header-${key}`, label: t(SECTION_LABELS[key]), header: true });
    sections[key].forEach((item) => {
      counter += 1;
      menu.push({ ...item, id: item.id && Array.isArray(item.content) ? `g${counter}` : `i${counter}` });
    });
  });
  return menu;
};

export default buildMetisMenu;
